module.exports = function(bootstrap) {
    bootstrap.directive('acceptingNewPatients', [function() {
        return {
            restrict: 'A',
            replace: true,
            scope: { acceptingNewPatients: '=' },
            template: '<span class="acceptingNewPatients"><span data-button-builder data-toggle="acceptingNewPatients && acceptingNewPatients.indexOf(\'O\') > -1" data-icon-classes="\'hm-icon icon-acceptingnewpatients btn-icon\'" data-modal-text="\'Accepting new patients for your health plan.\'" data-name="\'accepting new patients\'"></span></span>'
        };
    }]);
};